import { Component, OnInit } from '@angular/core';
import { LoadingService } from '@schoolbelle/common/loading';
import { Subscription } from 'rxjs';
import { ChangeEvent } from 'ngx-virtual-scroller';
import { AuthService, SurveyService, RepliesService } from '../../services';
import { Survey, ReplyItem, ForgeryStore } from '../../classes';
import { TableService } from './table.service';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  list: ReplyItem[] = [];
  survey: Survey;
  loadingIntialReplies: boolean = true;
  subscription = new Subscription();
  vsStartIndex: number;
  vsEndIndex: number;
  canForge: boolean = false;
  store: ForgeryStore;

  constructor(
    public repliesService: RepliesService,
    private surveyService: SurveyService,
    private loading: LoadingService,
    private auth: AuthService,
    private table:TableService,
  ) {
    this.store = this.repliesService.store;
  }

  ngOnInit() {
    const surveyData = this.surveyService.data;
    if (!surveyData) throw new Error('surveyData not found!');

    this.survey = new Survey(surveyData.id);
    this.survey.load(this.surveyService.data);
    this.canForge = typeof this.auth.getSurveyScope('reply') === 'string';
    this.subscription.add(
      this.repliesService.watch(surveyData.id).subscribe(list => {
        if (this.loadingIntialReplies) this.loadingIntialReplies = false;
        if (list) this.list = list;
      })
    );
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.repliesService.store.empty();
    this.repliesService.order.empty();
    this.repliesService.filter.empty();
  }
  onVsChange($event: ChangeEvent) {
    this.vsStartIndex = $event.start;
    this.vsEndIndex = $event.end;
  }
  trackById(index, item: ReplyItem) {
    return item.id;
  }

  saveChanges() {
    let promise = this.repliesService.forgeSave(this.survey);
    this.loading.open({ message: 'ì ì¥íë ì¤ìëë¤...', busy: promise });
  }
  cancelChanges() {
    this.repliesService.cancelChanges();
  }
  downloadExcel(){
    this.table.downloadAsExcel(this.survey, this.repliesService.currentList);
	}

}
